import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, blueMui, greyMui, orangeMui, redMui } from "@ryde/theme";

import {
  CAPTIONED_LOADER_SPIN_CCW,
  CAPTIONED_LOADER_SPIN_CW,
  CAPTIONED_LOADER_SPIN_SIZE,
} from "./captioned-loader.constants";

export const CaptionedLoaderStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "captioned-loader",
})`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  padding: 28px 36px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(10px);
  box-shadow:
    0 12px 40px rgba(15, 23, 42, 0.14),
    0 0 0 1px rgba(255, 255, 255, 0.9) inset;
  & .ryde-captioned-loader__spinner {
    position: relative;
    width: ${CAPTIONED_LOADER_SPIN_SIZE};
    height: ${CAPTIONED_LOADER_SPIN_SIZE};
    flex-shrink: 0;
  }
  & .ryde-captioned-loader__svg {
    display: block;
    width: ${CAPTIONED_LOADER_SPIN_SIZE};
    height: ${CAPTIONED_LOADER_SPIN_SIZE};
    overflow: visible;
  }
  & .ryde-captioned-loader__ring-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: ${CAPTIONED_LOADER_SPIN_SIZE};
    height: ${CAPTIONED_LOADER_SPIN_SIZE};
    transform-origin: 50% 50%;
    will-change: transform;
    animation-duration: 4.2s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-play-state: running;
  }
  & .ryde-captioned-loader__ring-layer--outer {
    animation-name: ${CAPTIONED_LOADER_SPIN_CW};
  }
  & .ryde-captioned-loader__ring-layer--middle {
    animation-name: ${CAPTIONED_LOADER_SPIN_CCW};
    animation-duration: 3.4s;
  }
  & .ryde-captioned-loader__ring-layer--inner {
    animation-name: ${CAPTIONED_LOADER_SPIN_CW};
    animation-duration: 2.6s;
  }
  & .ryde-captioned-loader__guide {
    fill: none;
    stroke: ${blueGreyMui._100};
    stroke-width: 1;
  }
  & .ryde-captioned-loader__arc {
    fill: none;
    stroke-width: 3.5;
    stroke-linecap: round;
  }
  & .ryde-captioned-loader__ring-layer--outer .ryde-captioned-loader__arc {
    stroke: ${blueMui._500};
    stroke-dasharray: 68 148;
  }
  &
    .ryde-captioned-loader__ring-layer--outer
    .ryde-captioned-loader__arc--offset {
    stroke: ${blueMui._200};
    stroke-dasharray: 46 170;
    stroke-dashoffset: -112;
  }
  & .ryde-captioned-loader__ring-layer--middle .ryde-captioned-loader__arc {
    stroke: ${redMui._400};
    stroke-dasharray: 54 104;
  }
  &
    .ryde-captioned-loader__ring-layer--middle
    .ryde-captioned-loader__arc--offset {
    stroke: ${redMui._100};
    stroke-dasharray: 38 120;
    stroke-dashoffset: -78;
  }
  & .ryde-captioned-loader__ring-layer--inner .ryde-captioned-loader__arc {
    stroke: ${orangeMui._600};
    stroke-dasharray: 36 68;
  }
  &
    .ryde-captioned-loader__ring-layer--inner
    .ryde-captioned-loader__arc--offset {
    stroke: ${orangeMui._200};
    stroke-dasharray: 28 76;
    stroke-dashoffset: -52;
  }
  & .ryde-captioned-loader__caption {
    margin: 0;
    max-width: 220px;
    text-align: center;
    font-size: 0.9375rem;
    line-height: 1.45;
    color: ${greyMui._700};
    font-weight: 600;
    letter-spacing: 0.01em;
  }
`;
